import React from 'react';

import ConsolidatedMarksReportContainer from '../../ConsolidatedMarksReport/ConsolidatedMarksReportContainer';
import ExamsCrudContainer from '../../Exams/ExamsCrudContainer';
import PendingFeeReportContainer from '../../PendingFeeReport/PendingFeeReportContainer';
import ImportRollOverUsersContainer from '../../UploadCsv/ImportRolloverUsersContainer';
import { NativePage } from './nativePages';
import CashFlowStatementContainer from '../../CashFlowStatement';
import SearchStudentFeeEntryContainer from '../../SearchStudentFeeEntry';
import OutstandingFeeReport from '../../OutstandingFeeReport/OutstandingFeeReport';
import RollNoUpdatePage from '../../RollNoUpdate/RollNoUpdatePage';
import FinalPromotionPage from '../../FinalPromotion/FinalPromotionPage';
import StaffProfilePage from '../../Staff';
import StudentProfileContainer from '../../StudentProfile';
import PendingFeeSummaryPage from '../../PendingFeeSummary';
import DailyBookPage from '../../DailyBook/DailyBookPage';
import IdCardsPage from '../../IdCards/IdCardsPage';
import AttendanceReportPage from '../../AttendanceReport/AttendanceReportPage';
import CancelledPaymentsLogPage from '../../CancelledPaymentsLog/CancelledPaymentsLogPage';
import ProvisionalPromotionPage from '../../ProvisionalPromotion/ProvisionalPromotionPage';
import FeeStructurePage from '../../FeeStructure';
import ChequeDetailReportPage from '../../ChequeDetailReport/ChequeDetailReportPage';
import LCReportPage from '../../LCReport';
import RolloverStatusPage from '../../RolloverStatus/RolloverStatusPage';
import DeclarationSetupPage from '../../DeclarationSetup/DeclarationSetupPage';
import HashtagsPage from '../../Hashtags/HashtagsPage';
import StudentsElectiveSubjectsPage from '../../ElectivesAssignment/ElectivesAssignment';
import MarksAnalytics from '../../MarksAnalytics/MarksAnalytics';
import TransactionStatusUpdate from '../../TransactionStatusUpdate/TransactionStatusUpdate';
import SubjectContainer from '../../Subjects';
import ScoringTypesContainer from '../../ScoringTypes';
import RolloverDashboardPage from '../../RolloverDashboard/RolloverDashboardPage';
import StudentTransportReportPage from '../../StudentTransportReport/StudentTransportReportPage';
import AssessmentOverviewContainer from '../../AssessmentOverview';
import FullPaymentConcessionPage from '../../FullPaymentConcession';
import LiveTripsDashboardPage from '../../LiveTripsDashboard';
import BusManagementPage from '../../BusManagement/BusManagementPage';
import RoutesManagementContainer from '../../RoutesManagement/RoutesManagementContainer';
import AcademicTermsContainer from '../../AcademicTerms';
import ChequeStatusUpdate from '../../ChequeStatusUpdate/ChequeStatusUpdate';
import SchoolConfigurationsPage from '../../SchoolConfigurations/SchoolConfigurationsPage';
import StaffAttendancePage from '../../StaffAttendance/StaffAttendancePage';
import StaffAttendanceReportPage from '../../StaffAttendanceReport/StaffAttendanceReportPage';

type NativePageComponentMap = {
  [key in NativePage]: React.ComponentType;
};

export const nativePageComponentMap: NativePageComponentMap = {
  [NativePage.IMPORT_USERS]: ImportRollOverUsersContainer,
  [NativePage.EXAMS]: ExamsCrudContainer,
  [NativePage.ATTENDANCE_TRACKING_REPORT]: AttendanceReportPage,
  [NativePage.PENDING_FEE_REPORT]: PendingFeeReportContainer,
  [NativePage.CHEQUE_DETAIL_REPORT]: ChequeDetailReportPage,
  [NativePage.CASH_FLOW_STATEMENT]: CashFlowStatementContainer,
  [NativePage.CANCELLED_PAYMENTS_LOG]: CancelledPaymentsLogPage,
  [NativePage.CONSOLIDATED_MARKS_REPORT]: ConsolidatedMarksReportContainer,
  [NativePage.SEARCH_STUDENT_FEE_ENTRY]: SearchStudentFeeEntryContainer,
  [NativePage.FINAL_PROMOTION]: FinalPromotionPage,
  [NativePage.SCHOOL_STAFF_SEARCH]: StaffProfilePage,
  [NativePage.STUDENT_PROFILE]: StudentProfileContainer,
  [NativePage.PENDING_FEE_SUMMARY_REPORT]: PendingFeeSummaryPage,
  [NativePage.ROLL_NO_UPDATE]: RollNoUpdatePage,
  [NativePage.OUTSTANDING_FEE_REPORT]: OutstandingFeeReport,
  [NativePage.DAILY_FEE_BOOK_PAGE]: DailyBookPage,
  [NativePage.PHOTO_ID_CARDS]: IdCardsPage,
  [NativePage.PROVISIONAL_PROMOTION]: ProvisionalPromotionPage,
  [NativePage.ROLLOVER_STATUS]: RolloverStatusPage,
  [NativePage.FEE_STRUCTURE_PAGE]: FeeStructurePage,
  [NativePage.LC_REPORT]: LCReportPage,
  [NativePage.DECLARATIONS]: DeclarationSetupPage,
  [NativePage.HASHTAGS_MANAGEMENT]: HashtagsPage,
  [NativePage.ACADEMIC_YEAR_WISE_TERMS]: AcademicTermsContainer,
  [NativePage.STUDENT_ELECTIVE_SUBJECTS_MAPPING]: StudentsElectiveSubjectsPage,
  [NativePage.MARKS_ANALYTICS]: MarksAnalytics,
  [NativePage.IMPORT_CHEQUE_STATUS_REPORT]: ChequeStatusUpdate,
  [NativePage.IMPORT_TRANSACTION_STATUS_REPORT]: TransactionStatusUpdate,
  [NativePage.SUBJECTS_MANAGEMENT]: SubjectContainer,
  [NativePage.SCORING_TYPES]: ScoringTypesContainer,
  [NativePage.STUDENT_TRANSPORT_REPORT]: StudentTransportReportPage,
  [NativePage.ROLLOVER_DASHBOARD]: RolloverDashboardPage,
  [NativePage.ROLLOVER_DASHBOARD_SCHOOL_AND_GRADEWISE]: () => (
    <RolloverDashboardPage getGradeWiseSummary={true} />
  ),
  [NativePage.ASSESSMENTS_OVERVIEW]: AssessmentOverviewContainer,
  [NativePage.FULL_PAYMENT_CONCESSION]: FullPaymentConcessionPage,
  [NativePage.SCHOOL_CONFIGURATIONS]: SchoolConfigurationsPage,
  [NativePage.LIVE_TRIPS]: LiveTripsDashboardPage,
  [NativePage.BUSES]: BusManagementPage,
  [NativePage.ROUTES_MANAGEMENT]: RoutesManagementContainer,
  [NativePage.STAFF_ATTENDANCE]: StaffAttendancePage,
  [NativePage.STAFF_ATTENDANCE_REPORT]: StaffAttendanceReportPage
};

export const isNativePage = (value: string): value is NativePage => {
  return Object.values(NativePage).includes(value as NativePage);
};
